import React, { FunctionComponent } from "react";
import styles from "./Loading.module.css";
import { connect } from "react-redux";
import useMediaQuery from "@mui/material/useMediaQuery";

type props = {
  logo?: boolean;
  progress: any; // Redux progress state (kept as-is)
  theme: any; // true = light mode, false = dark mode
  role: any;
  subtext?: boolean;
};

/**
 * Loading Component
 *
 * Displays a full-width spinner overlay.
 * Background color changes based on theme.
 * Layout adjusts for mobile screens (max-width: 900px).
 *
 * NOTE: Functionality is unchanged — only documented and cleaned.
 */
const Loading: FunctionComponent<props> = ({ logo, progress, theme, role, subtext }) => {

  // Detect if screen width is less than 900px
  const isMobile = useMediaQuery('(max-width: 900px)');

  return (
    <div className={styles.parent}
      style={{
        backgroundColor: theme ? "#F5F5F5" : "#000000e1", // Light/Dark BG
        width: "100vw",
        height: "100%",                                       // Full height
        marginTop: "3.5rem",
        marginLeft: isMobile ? undefined : "10px",            // Desktop offset
        zIndex: 10000                                         // Overlay
      }}
    >
      <div className={styles.spinner} style={{ marginBottom: isMobile ? undefined : "6%", marginRight: isMobile ? undefined : "13%" }}>
        <div className={styles.innerSpinner}>
        </div>
      </div>
    </div>
  );
};

/**
 * Maps Redux state to component props.
 */
const mapStateToProps = (state: any) => {
  return {
    progress: state.progress,
    theme: state.theme.isLightMode,
    role: state.user.role,
  };
};

export default connect(mapStateToProps)(Loading);
